export const VERIFY = {
  EMAIL: {
    VERIFICATION_IN_PROGRESS: "VERIFICATION_IN_PROGRESS",
    VERIFICATION_SUCCESS: "VERIFICATION_SUCCESS",
    VERIFICATION_FAILED: "VERIFICATION_FAILED",
    TEXTS: {
      SUCCESS: {
        HEADING: "Verified Successfully",
        SUBHEADING: "Congratulation! Your email is now verified",
        BODY: "You may close this tab and return to your previous tab.",
      },
      FAILURE: {
        HEADING: "Oops! Something went wrong",
        SUBHEADING:
          "It seems your verification link might have expired or something went wrong. ",
        BODY: "You can try again or download our app",
      },
      LOADING: {
        HEADING: "We’re verifying your account",
      },
    },
  },
};
